export default __webpack_public_path__ + "static/media/p18.5f6c5081.jpeg";